export default __webpack_public_path__ + "static/do-overflow-5f51c393b76d22f43026ca492d68386b.png";